// import AlertsContext from 'common/contexts/alerts';
import useRouter from "common/hooks/use-router";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CrudEdit from "common/components/Crud/CrudEdit";
import { TableColumn } from "common/components/DataTable/DataTable";
import { CrudHeaderAction } from "common/components/Crud/components/CrudHeader";
import { CrudFilter } from "common/components/Crud/components/CrudFilters";
import CrudList from "common/components/Crud/CrudList";
import type { User } from "types";
import AdminForm from "./AdminForm";

function SidebarAdminForm({ ...props }: any) {
  return <CrudEdit collectionName="users" Form={AdminForm} {...props} />;
}

function Admins() {
  const { t } = useTranslation();
  const { navigate } = useRouter();

  const canManageAdmins = true;

  const handleDetail = (id: any) => {
    navigate(`/administrators/${id}`);
  };

  const columns: TableColumn<User>[] = useMemo(
    () => [
      {
        field: "username",
        header: t("users.username"),
        sortable: true,
        customRender: (rowData: User) => {
          return <span className="font-bold">{rowData.username}</span>;
        },
      },
      {
        field: "email",
        header: t("users.email"),
        sortable: true,
        customRender: (rowData: User) => {
          return (
            <span>
              {rowData.email ||
                (rowData.email?.includes("fakemail.com")
                  ? "-"
                  : rowData.email) ||
                "-"}
            </span>
          );
        },
      },
    ],
    [t],
  );

  const actions: CrudHeaderAction[] = useMemo(() => {
    return [
      {
        title: t("common.new"),
        icon: "PlusIcon",
        action: "openSidebar",
        // type: "white",
        disabled: !canManageAdmins,
      },
    ];
  }, [canManageAdmins, t]);

  const filters: CrudFilter[] = useMemo(() => {
    return [
      {
        name: "name$containsi",
        label: t("users.name"),
        renderType: "input",
        icon: "MagnifyingGlassIcon",
      },
    ];
  }, [t]);

  return (
    <CrudList
      collectionName="users"
      columns={columns}
      headerActions={actions}
      filters={filters}
      defaultFilters={{ onlyAdmins: true }}
      defaultSort="username:ASC"
      canDelete={canManageAdmins}
      canEdit={canManageAdmins}
      canSeeDetails={false}
      onNavigate={handleDetail}
      formMode="sidebar"
      SidebarFormComponent={SidebarAdminForm}
      actionsHeader=""
      className="pt-2 px-4"
    />
  );
}

export default Admins;
